var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepcityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 52,
    viewBox: "0 0 155 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pepcity logo 1",
    clipPath: "url(#clip0_27237_248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M140.4 31.3797L137.323 21.9447H130.368L136.13 37.0727L128.168 47.6828H135.65L155 21.9447H147.483L140.4 31.3797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M95.534 47.6828H101.641L106.42 21.9447H100.307L95.534 47.6828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M127.285 21.9447H109.111L108.058 27.6091H114.931L111.205 47.6828H117.323L121.05 27.6091H129.444L127.285 21.9447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M80.1966 38.824C79.7579 37.6888 79.6936 36.3312 79.9977 34.8138C80.9278 30.3245 84.2445 27.4666 89.4154 27.4666H95.768C95.961 26.4284 96.3471 24.3292 96.7799 21.9504H89.6903C86.3152 21.9504 83.3787 22.6692 80.9629 23.947C76.9267 26.0804 74.3647 29.7825 73.7037 34.2833C73.3118 36.8959 73.6452 39.3031 74.5752 41.3396C75.09 42.4577 75.7861 43.4673 76.6518 44.3287C78.7459 46.4279 81.8052 47.6886 85.5782 47.6886H92.0945C92.0945 47.6886 92.5975 44.922 93.1006 42.1724H86.7246C83.0629 42.1724 80.9921 40.8776 80.2025 38.8354",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.3632 21.8306H12.8747L10.3478 35.4355H16.4546L17.958 27.3467H23.3395C28.6099 27.3467 33.4299 23.4107 34.3366 18.5221C35.0326 14.7743 33.2193 11.5855 29.9611 10.3021C28.9667 9.91415 27.8436 9.69739 26.6152 9.69739C26.6152 9.69739 16.3201 9.69739 12.0032 9.69739C12.6466 11.3916 14.109 15.2135 14.109 15.2135H25.5916C27.4634 15.2135 28.5748 16.6453 28.2238 18.5163C27.8729 20.3931 26.235 21.8249 24.3573 21.8249",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.6633 25.2133L54.6987 19.623H42.0696L42.8593 15.3618L56.2956 15.3675L54.1371 9.69739H37.7995L33.0263 35.4355H52.9029L53.9558 29.7711H40.186L41.0284 25.2133H53.6633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79.5766 18.5221C80.2727 14.7743 78.4593 11.5855 75.2011 10.3021C74.2126 9.91415 73.0836 9.69739 71.8552 9.69739H57.2432C57.8866 11.3916 59.349 15.2135 59.349 15.2135H70.8316C72.7034 15.2135 73.8148 16.6453 73.4638 18.5163C73.1187 20.3931 71.475 21.8249 69.6032 21.8249H58.1148L55.5878 35.4298H61.6947L63.198 27.341H68.5795C73.8499 27.341 78.6699 23.405 79.5766 18.5163",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.9851 40.3185C28.6625 43.513 25.6851 45.4753 23.7724 46.5591C22.7604 47.1295 21.9298 47.5231 21.3448 47.7798C20.7599 47.5288 19.9409 47.1409 18.9465 46.5819C17.0571 45.5209 14.1324 43.6099 10.9152 40.5182C5.90799 35.6352 3.14703 29.0581 3.14703 21.9961V5.00274C4.0888 4.79167 5.3055 4.53498 6.75032 4.28398C10.067 3.70784 15.2906 3.01761 21.3507 3.01761C27.4107 3.01761 32.6343 3.70214 35.951 4.28398C37.3958 4.53498 38.6125 4.78597 39.5543 5.00274V6.9137H42.6955V2.66394C42.6955 2.66394 33.6346 0 21.3448 0C9.05502 0 0 2.66965 0 2.66965V22.0018C0 29.6171 2.9189 37.0385 8.68066 42.6516C15.5597 49.2687 21.3448 51.0427 21.3448 51.0427C21.3448 51.0427 27.13 49.2744 34.2137 42.4577C35.5533 41.1571 36.7349 39.7367 37.7585 38.225H33.8978C33.3012 38.9609 32.6636 39.6568 31.9792 40.3242",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27237_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 51.037,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepcityLogo);
export default __webpack_public_path__ + "static/media/pepcity-logo.9676fbf4ce6f8c78e4b33f7f22fea253.svg";
export { ForwardRef as ReactComponent };